var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgApple = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "144.000000pt",
    height: "144.000000pt",
    viewBox: "0 0 144.000000 144.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,144.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M912 1383 c-94 -33 -185 -149 -194 -248 -3 -39 -2 -40 30 -43 105 -10 242 145 242 274 0 39 -10 41 -78 17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437 1060 c-127 -32 -223 -136 -257 -279 -18 -77 -8 -247 20 -336 50 -158 161 -332 244 -380 54 -32 89 -31 173 1 91 35 165 35 256 0 37 -14 79 -26 94 -26 49 0 112 40 164 104 46 57 139 223 139 250 0 6 -16 20 -36 31 -43 23 -86 71 -116 128 -17 33 -22 60 -22 122 -1 98 20 150 88 216 55 54 54 64 -13 113 -100 73 -203 84 -341 36 -102 -36 -114 -37 -192 -5 -71 29 -146 38 -201 25z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApple);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apple.aefb3f49e6b16e089234753a6d7e7ecb.svg";